/* eslint-disable no-use-before-define */
import { decompress } from 'compress-json'
import * as Sentry from '@sentry/react'
import * as Helpers from '#/helpers'

const equal = require('fast-deep-equal')

export const propertyURL = (type) =>
  new Promise((resolve) => {
    AP.context.getContext((context) => {
      let url = context.jira?.issue
        ? `/rest/api/3/issue/${context.jira.issue.id}/properties/appsplusEmbedPanel`
        : `/rest/api/3/dashboard/${context.jira.dashboard.id}/items/${context.jira.dashboardItem.id}/properties/appsplusEmbedPanel`
      if (type === 'tabs') {
        url = context.jira?.issue
          ? `/rest/api/3/issue/${context.jira.issue.id}/properties/appsplusEmbedTabs`
          : `/rest/api/3/dashboard/${context.jira.dashboard.id}/items/${context.jira.dashboardItem.id}/properties/appsplusEmbedTabs`
      }
      resolve(url)
    })
  })

export const getProperty = (url) =>
  new Promise((resolve) => {
    let data = []
    const checkData = async (num = 0) => {
      await AP.request(`${url}:${num}`)
        .then((res) => JSON.parse(res.body))
        .then(async (res) => {
          await fetchData(res, num)
        })
        .catch(async () => {
          await fetchData(null, num)
        })
    }
    const fetchData = (res, num) => {
      if (!res || res.value.length === 0) {
        resolve(data)
      } else {
        data = [...data, ...res.value.map((item) => decompress(item))]
        checkData((num += 1))
      }
    }
    checkData()
  })

export const setProperty = (url, data) =>
  new Promise((resolve) => {
    data = Helpers.chunkToLimit(data, 32)
    const checkData = async (num = 0) => {
      await AP.request(`${url}:${num}`)
        .then((res) => JSON.parse(res.body))
        .then(async (res) => {
          await pushData(res, num)
        })
        .catch(async () => {
          await pushData(null, num)
        })
    }
    const pushData = (res, num) => {
      const oldValue = res && res.value ? res.value : false
      const newValue = data[num] ? data[num] : []
      if (!equal(oldValue, newValue)) {
        AP.request({
          url: `${url}:${num}`,
          type: 'PUT',
          contentType: 'application/json',
          data: JSON.stringify(newValue),
        }).catch(({ err }) => {
          Sentry.addBreadcrumb({ message: 'setProperty' })
          Sentry.captureMessage(err)
        })
      }
      if (newValue.length > 0) {
        checkData((num += 1))
      } else {
        resolve()
      }
    }
    checkData()
  })
